import { useMyLessonsContext } from '../context/MyLessonsContextProvider';
import MyLessonsAssignLessonsAction from './MyLessonsAssignLessonsAction';
import { flatten, unique } from '../../../../../utils/ArrayUtils';
import './MyLessonsAssignmentSelectionActions.scss';
import LessonsAddToGroupPlay from '../../../../lessons/lessonactions/lesson-multi-selection-actions/LessonsAddToGroupPlay';

import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  selectedLessonIds: [],
};

const MyLessonsAssignmentSelectionActions = (p) => {
  const { selectedLessonIds } = { ...defaultProps, ...filterUndefined(p) };
  const { myLessonsDomain } = useMyLessonsContext();
  const { lessonData, selectedDates } = myLessonsDomain.domainData;
  const { lessons } = lessonData;

  const allLessons = unique(flatten(lessons.map((subjectWithLessons) => subjectWithLessons.lessons)), 'id');

  return (
    <div className='my-lessons-assignment-selection-actions'>
      <LessonsAddToGroupPlay
        lessons={allLessons}
        selectedLessonIds={selectedLessonIds}
      />
      <MyLessonsAssignLessonsAction
        lessons={allLessons}
        selectedLessonIds={selectedLessonIds}
        key='my-lessons-assign-to-others'
        selectedDates={selectedDates}
      />
    </div>
  );
};

export default MyLessonsAssignmentSelectionActions;
